<template>
<article class="revenue-log">
    <section class="search-section">
      <el-form ref="searchFormRef" :model="searchForm" :rules="searchRules" label-position="top">
        <div class="search-row">
          <el-form-item :label="$t('日期')" prop="dateRange">
            <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="-" :start-placeholder="$t('开始日期')" :end-placeholder="$t('结束日期')" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="datePickerOptions" :key="datePickerKey" @change="handleDateChange" @close="handleCalendarClose" @blur="handleDateBlur"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('酒店')">
            <el-select v-model="searchForm.hotelVid" :placeholder="$t('请选择')" style="width: 180px">
              <el-option v-for="item in hotelOptions" :key="item.hotelVid" :label="item.hotelName" :value="item.hotelVid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('入账科目属性')">
            <el-select v-model="searchForm.normal" :placeholder="$t('请选择')">
              <el-option :label="$t('付款')" value="C"></el-option>
              <el-option :label="$t('费用')" value="D"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('转账记录')">
            <el-select v-model="searchForm.transfer" :placeholder="$t('请选择')">
              <el-option :label="$t('不显示')" :value="false"></el-option>
              <el-option :label="$t('显示')" :value="true"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="search-btn-item">
            <el-button type="primary" @click="handleSearch">{{$t('查询')}}</el-button>
          </el-form-item>
        </div>
      </el-form>
    </section>

    <section class="table-section">
      <div class="table-header">
        <el-button type="default" @click="handleExportExcel">{{$t('导出excel')}}</el-button>
        <div class="table-summary">
          <span class="summary-label">{{$t('总费用:')}}</span>
          <span class="summary-value expense">{{summary.totalExpense}}</span>
          <span class="summary-label">{{$t('总付款:')}}</span>
          <span class="summary-value payment">{{summary.totalPayment}}</span>
          <span class="summary-label">{{$t('余额:')}}</span>
          <span class="summary-value balance">{{summary.balance}}</span>
        </div>
      </div>
      <div class="table-wrapper">
        <el-table :data="tableData" border height="100%" class="revenue-table">
        <el-table-column prop="hotelName" :label="$t('酒店')" width="150"></el-table-column>
        <el-table-column prop="date" :label="$t('日期')" width="120"></el-table-column>
        <el-table-column prop="time" :label="$t('时间')" width="160"></el-table-column>
        <el-table-column prop="account" :label="$t('账号')" width="120"></el-table-column>
        <el-table-column prop="name" :label="$t('姓名')" width="100"></el-table-column>
        <el-table-column prop="roomNo" :label="$t('房号')" width="100"></el-table-column>
        <el-table-column prop="subject" :label="$t('入账科目')" width="140"></el-table-column>
        <el-table-column prop="expense" :label="$t('费用')" width="120" align="right">
          <template slot-scope="scope">
            {{formatNumber(scope.row.expense)}}
          </template>
        </el-table-column>
        <el-table-column prop="payment" :label="$t('付款')" width="120" align="right">
          <template slot-scope="scope">
            {{formatNumber(scope.row.payment)}}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('操作方式')" width="100"></el-table-column>
        <el-table-column prop="entryMode" :label="$t('入账方式')" width="140"></el-table-column>
        <el-table-column prop="channel" :label="$t('渠道')" width="100"></el-table-column>
        <el-table-column prop="channelOrderNo" :label="$t('渠道订单号')" width="120"></el-table-column>
        <el-table-column prop="arrivalDate" :label="$t('抵达日期')" width="120"></el-table-column>
        <el-table-column prop="departureDate" :label="$t('离店日期')" width="120"></el-table-column>
        <el-table-column prop="shift" :label="$t('班次')" width="80"></el-table-column>
        <el-table-column prop="operator" :label="$t('操作员')" width="100"></el-table-column>
        </el-table>
      </div>
    </section>
  </article>
</template>

<script>
import { intl } from "@tci18n/vue2";import ExportUtil from '@/libs/export';
import reportAPI from '@/view/organization/api/report';
import _ from 'lodash';
import commonApi from '@/view/common/api';
import memberAPI from '@/view/organization/api/member';
import cacheHelper from '@/view/common/cache';

export default {
  name: 'RevenueLog',
  data() {
    return {
      searchForm: {
        dateRange: [],
        hotelVid: '',
        normal: '',
        transfer: false
      },
      hotelOptions: [],
      summary: {
        totalExpense: '0.00',
        totalPayment: '0.00',
        balance: '0.00'
      },
      tableData: [],
      // 当前操作周期中已选择的第一个日期（用于限制日期范围）
      rangePrepare: null,
      // 日期选择器的 key，用于强制重新渲染
      datePickerKey: 0,
      // 表单验证规则
      searchRules: {
        dateRange: [
        {
          validator: (rule, value, callback) => {
            if (value && value.length === 2 && value[0] && value[1]) {
              callback();
            } else {
              callback(new Error(intl.$t("请选择日期范围")));
            }
          },
          trigger: 'change'
        }]

      },
      // 日期选择器配置
      datePickerOptions: {
        // 打开日历默认定位到当前选择的日期范围
        defaultDate: () => {
          const dateRange = this.searchForm.dateRange;
          if (dateRange && dateRange.length === 2 && dateRange[0]) {
            return new Date(dateRange[0]);
          }
          return new Date();
        },
        // 日期不能超过今天
        disabledDate: (time) => {
          const timeStamp = time.getTime();
          const today = new Date();
          today.setHours(23, 59, 59, 999);

          // 不能选择未来日期
          if (timeStamp > today.getTime()) {
            return true;
          }

          // 如果已选择了第一个日期，限制另一个日期的可选范围（前后30天）
          if (this.rangePrepare) {
            const prepareDate = new Date(this.rangePrepare);
            const diffDays = Math.abs(timeStamp - prepareDate.getTime()) / (1000 * 60 * 60 * 24);
            if (diffDays > 30) {
              return true;
            }
          }

          return false;
        },
        // 监听日期选择，记录第一个选择的日期
        onPick: ({ maxDate, minDate }) => {
          let r = null;

          if (minDate && !maxDate) {
            // 只选择了开始日期
            r = minDate;
          } else if (maxDate && !minDate) {
            // 只选择了结束日期
            r = maxDate;
          } else {
            // 两个日期都选好了或都没选
            r = null;
          }

          this.rangePrepare = r;
        }
      },
      // 列配置，用于导出
      columns: [
      { key: 'hotelName', title: intl.$t("酒店"), width: 15 },
      { key: 'date', title: intl.$t("日期"), width: 12 },
      { key: 'time', title: intl.$t("时间"), width: 14 },
      { key: 'account', title: intl.$t("账号"), width: 12 },
      { key: 'name', title: intl.$t("姓名"), width: 10 },
      { key: 'roomNo', title: intl.$t("房号"), width: 10 },
      { key: 'subject', title: intl.$t("入账科目"), width: 14 },
      { key: 'expense', title: intl.$t("费用"), width: 12, align: 'right' },
      { key: 'payment', title: intl.$t("付款"), width: 12, align: 'right' },
      { key: 'operation', title: intl.$t("操作方式"), width: 10 },
      { key: 'entryMode', title: intl.$t("入账方式"), width: 14 },
      { key: 'channel', title: intl.$t("渠道"), width: 10 },
      { key: 'channelOrderNo', title: intl.$t("渠道订单号"), width: 12 },
      { key: 'arrivalDate', title: intl.$t("抵达日期"), width: 12 },
      { key: 'departureDate', title: intl.$t("离店日期"), width: 12 },
      { key: 'shift', title: intl.$t("班次"), width: 8 },
      { key: 'operator', title: intl.$t("操作员"), width: 10 }]

    };
  },
  computed: {
    tableWithTotal() {
      // 使用数据中的 expenseAmount 和 payAmount
      let expenseAmount = 0;
      let payAmount = 0;

      try {
        if (this.summary.totalExpense) {
          expenseAmount = parseFloat(this.summary.totalExpense.replace(/,/g, '')) || 0;
        }
        if (this.summary.totalPayment) {
          payAmount = parseFloat(this.summary.totalPayment.replace(/,/g, '')) || 0;
        }
      } catch (e) {
        console.error('计算合计行数据失败:', e);
      }

      const totalRow = {
        hotelName: intl.$t("合计"),
        date: '',
        time: '',
        account: '',
        name: '',
        roomNo: '',
        subject: '',
        expense: expenseAmount,
        payment: payAmount,
        operation: '',
        entryMode: '',
        channel: '',
        channelOrderNo: '',
        arrivalDate: '',
        departureDate: '',
        shift: '',
        operator: ''
      };
      return [...this.tableData, totalRow];
    }
  },
  created() {
    // 设置默认日期范围（开始和结束都是当天）
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    this.searchForm.dateRange = [dateStr, dateStr];
    this.getHotelOptions();
  },
  methods: {
    formatNumber(num) {
      return Number(num).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    handleSearch() {
      this.$refs['searchFormRef'].validate((valid) => {
        if (valid) {
          // 清空上次查询结果
          this.tableData = [];
          this.summary.totalExpense = '0.00';
          this.summary.totalPayment = '0.00';
          this.summary.balance = '0.00';
          this.fetchData();
        }
      });
    },
    getHotelOptions() {
      const currentUser = cacheHelper.getLocalCachedUserInfo();
      const currentUserId = currentUser && currentUser.userId;

      commonApi.hotelListByName().then((hotelRes) => {
        let hotelList = hotelRes.code == 200 && hotelRes.data ? hotelRes.data : [];
        hotelList = _.filter(hotelList, (it) => it.hotelVid !== '0' && it.hotelVid !== 0);

        memberAPI.memberInfo({ id: currentUserId }).then((memberRes) => {
          if (memberRes.code == 200 && memberRes.data) {
            const hotelVids = memberRes.data.hotelVids;

            if (!hotelVids || hotelVids === '') {
              this.hotelOptions = _.filter(hotelList, (it) => it.hotelVid != '');
              this.hotelOptions.unshift({ hotelVid: '', hotelName: intl.$t("全部酒店") });
            } else {
              const userHotelVids = hotelVids.split(',').filter((vid) => vid && vid !== '');
              this.hotelOptions = _.filter(hotelList, (it) => userHotelVids.includes(it.hotelVid));
            }
            // 默认选中第一条数据
            if (this.hotelOptions.length > 0) {
              this.searchForm.hotelVid = this.hotelOptions[0].hotelVid;
            }
            // 酒店数据获取完成后执行查询
            this.fetchData();
          }
        }).catch((err) => {
          console.error('获取当前用户信息失败', err);
          this.fetchData();
        });
      }).catch((err) => {
        console.error('获取酒店列表失败', err);
        this.hotelOptions = [];
        this.fetchData();
      });
    },
    handleDateChange(val) {
      // 日期选择完成后重置 rangePrepare，开始新的操作周期
      if (val && val.length === 2 && val[0] && val[1]) {
        this.rangePrepare = null;
      }
    },
    handleDateBlur() {
      // 失去焦点时检查日期是否被清空
      const dateRange = this.searchForm.dateRange;
      if (!dateRange || dateRange.length < 2 || !dateRange[0] || !dateRange[1]) {
        // 如果日期被清空，重置为当天
        const today = new Date().toISOString().split('T')[0];
        this.searchForm.dateRange = [today, today];
      }
    },
    handleCalendarClose() {
      // 关闭日历后重置 rangePrepare 和 key，确保下次打开日历从当前选择的日期开始
      this.rangePrepare = null;
      this.datePickerKey++;
    },
    async fetchData() {
      try {
        // 构建请求参数
        const params = {
          startDate: this.searchForm.dateRange[0],
          endDate: this.searchForm.dateRange[1],
          hotelVid: this.searchForm.hotelVid || '',
          normal: this.searchForm.normal,
          transfer: this.searchForm.transfer
        };

        // 调用接口
        const response = await reportAPI.blocBillingLog(params);

        if (response && response.code == 200 && response.data) {
          const result = response.data;
          const expenseAmount = result.expenseAmount || 0;
          const payAmount = result.payAmount || 0;
          const finTransactionResponseList = result.finTransactionResponseList || [];

          // 更新统计数据
          this.summary.totalExpense = expenseAmount.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          this.summary.totalPayment = payAmount.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          this.summary.balance = (payAmount - expenseAmount).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

          // 转换数据格式
          const data = finTransactionResponseList.map((item) => ({
            hotelName: item.hotelName,
            date: item.tranBdt,
            time: item.postTime,
            account: item.acctNo,
            name: item.guestName,
            roomNo: item.roomNo,
            subject: item.trnName,
            expense: item.normal === 'D' ? item.tranAmt : 0,
            payment: item.normal === 'C' ? item.tranAmt : 0,
            operation: item.postType === 'POST' ? intl.$t("入账") : item.postType,
            entryMode: item.trnName,
            channel: item.channelNo,
            channelOrderNo: item.chnlNo,
            arrivalDate: item.arrDt,
            departureDate: item.dptDt,
            shift: '',
            operator: item.createUser
          }));

          // 添加合计行
          const totalRow = {
            hotelName: intl.$t("合计"),
            date: '',
            time: '',
            account: '',
            name: '',
            roomNo: '',
            subject: '',
            expense: expenseAmount,
            payment: payAmount,
            operation: '',
            entryMode: '',
            channel: '',
            channelOrderNo: '',
            arrivalDate: '',
            departureDate: '',
            shift: '',
            operator: ''
          };
          this.tableData = [...data, totalRow];
        }
      } catch (error) {
        console.error('获取入账流水数据失败:', error);
        this.$notice.error(intl.$t("获取数据失败"));
      }
    },


    async handleExportExcel() {
      // 生成文件名：export-年月日-时分秒
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');
      const fileName = `export-${year}${month}${day}-${hour}${minute}${second}`;

      const success = await ExportUtil.exportExcel(this.tableData, this.columns, fileName, this.summary);
      if (success) {
        this.$notice.success(intl.$t("导出Excel成功"));
      } else {
        this.$notice.error(intl.$t("导出Excel失败"));
      }
    }

  }
};
</script>

<style lang="scss" scoped>
@import "@/style/const";
@import "@/style/mixins";

.revenue-log {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
}

.search-section {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.search-row {
  display: flex;
  align-items: flex-end;
  gap: 24px;
}

.search-btn-item {
  :deep(.el-form-item__label) {
    display: none;
  }
}



.table-section {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 220px);
}

.table-wrapper {
  flex: 1;
  overflow: hidden;
  max-height: calc(100vh - 300px);
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  .el-button {
    margin-right: 12px;
  }

  .table-summary {
    display: flex;
    align-items: center;

    .summary-label {
      font-size: 14px;
      color: $text-color;
      margin-right: 8px;
      margin-left: 24px;

      &:first-child {
        margin-left: 0;
      }
    }

    .summary-value {
      font-size: 16px;
      font-weight: 600;

      &.expense {
        color: $error-color;
      }

      &.payment {
        color: $success-color;
      }

      &.balance {
        color: $theme-color;
      }
    }
  }
}

.revenue-table {
  width: 100%;
  table-layout: fixed;

  .account-link {
    color: $theme-color;
    text-decoration: underline;

    &:hover {
      color: darken($theme-color, 10%);
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
